import React, { useEffect, useState } from "react";
import { useLocation,useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./secondpagee.css";
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import icdLogo from "./container-corporation-of-india-logo-concor.svg";
import { useMemo } from "react";
import bgImage from "./bg1.jpg"; 

const Secondpagee = () => {
  
const token = localStorage.getItem("authToken");
const user = localStorage.getItem("user");
const parsedUser = user ? JSON.parse(user) : null;

   const navigate = useNavigate();
  const location = useLocation();
  const { formData, responseData } = location.state || { formData: {}, responseData: {} };
  const [isLoaded, setIsLoaded] = useState(false);

    const [showModal, setShowModal] = useState(false);
 const [popupImages, setPopupImages] = useState([]);

const handleOpenModal = (images) => {
  setPopupImages(images.filter(img => img.url)); // only keep images that exist
  setShowModal(true);
};

  const handleCloseModal = () => {
    setShowModal(false);
    setPopupImages("");
  };

  useEffect(() => {
    setTimeout(() => setIsLoaded(true), 300);
  }, []);

  
  const [searchForm, setSearchForm] = useState({ transactionType: "", crnNumber: "" });
  const [isLoading, setIsLoading] = useState(false);
  
  // put with your other handlers:
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchForm(prev => ({ ...prev, [name]: value }));
  };
  
  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    const { transactionType, crnNumber } = searchForm;
    if (!transactionType || !crnNumber) return;
  
    setIsLoading(true);
    try {
      const endpoint =
        transactionType === "Export"
          ? `https://kycl.in/api/api/export?crnNumber=${crnNumber}`
          : `https://kycl.in/api/api/import?crnNumber=${crnNumber}`;
  
      const response = await axios.get(endpoint);
      if (!response?.data) return;
  
      localStorage.setItem("searchResults", JSON.stringify(response.data));
      const dataArray = transactionType === "Export" ? response.data.gate_data : response.data.rake_in_data;
      const hasIn = Array.isArray(dataArray) && dataArray.some(item => item.type === "IN");
  
      if (hasIn) {
        navigate(transactionType === "Export" ? "/Export" : "/Import", {
          state: { formData: searchForm, responseData: response.data }, // keeps same shape for target page
        });
      } else {
        console.warn("No 'IN' entries found.");
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsLoading(false);
    }
  };
  // Status badge component
  const StatusBadge = ({ status }) => (
    <span className={`badge ${status === 'Y' ? 'bg-danger' : 'bg-success'}`}>
      {status === 'Y' ? 'Yes' : 'No'}
    </span>
  );

  // Timeline component
const TimelineItem = ({ title, date, time, wagon, last, onClick, gate_no, destination, JOB_NO }) => (
  <div
    className={`timeline-item ${last ? "last-record" : "mb-3"}`}
    style={{ cursor: "pointer" }}
    onClick={onClick}
  >
    <div className={`timeline-badge ${last ? "bg-success" : "bg-secondary"}`}></div>
    <div
      className={`timeline-content p-3 rounded shadow-sm ${
        last ? "bg-warning text-dark border border-danger" : "bg-light"
      }`}
    >
      <h6 className={`mb-1 ${last ? "text-danger fw-bold" : "text-primary"}`}>
        {title}
      </h6>

      {wagon && (
        <div className="text-dark mb-1">
          <small style={{ fontWeight: "bold" }}>
            Wagon No: <strong>{wagon}</strong>
          </small>
        </div>
      )}

      {gate_no && (
        <div className="text-dark mb-1">
          <small style={{ fontWeight: "bold" }}>
            Gate No: <strong>{gate_no}</strong>
          </small>
        </div>
      )}

      {destination && (
        <div className="text-dark mb-1">
          <small style={{ fontWeight: "bold" }}>
            Dest: <strong>{destination}</strong>
          </small>
        </div>
      )}

      {JOB_NO && (
        <div className="text-dark mb-1">
          <small style={{ fontWeight: "bold" }}>
            JOB NO: <strong>{JOB_NO}</strong>
          </small>
        </div>
      )}

      <div className="d-flex justify-content-between">
        {date && <span className="text-muted">{date}</span>}
        {time && <span className="fw-bold">{time}</span>}
      </div>
    </div>
  </div>
);


  // Format date and time separately
  const formatDateTime = (dateString) => {
    if (!dateString) return { date: "N/A", time: "N/A" };
    
    const dateObj = new Date(dateString);
    return {
      date: dateObj.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      }),
      time: dateObj.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      })
    };
  };

  const [showDetailModal, setShowDetailModal] = useState(false);
  const [detailData, setDetailData] = useState(null);

  // Build & sort events
  // ---------------- Build & sort events (only important yard items) ----------------
  const events = [];

  // Gate In (first gate record)
  if (responseData.gate_data?.length > 0) {
    const rec = responseData.gate_data[0];
    events.push({ key: 'gate-in', title:    responseData?.userInput?.length === 10 ? "Cargo Gate in" : "Gate in", gate_no: rec.gate_no, datetime: rec.gate_in_time, record: rec });
  }

  // Carting Start & End (keep both)
  if (responseData.carting_data?.length > 0) {
    const c = responseData.carting_data[0];
    events.push({ key: 'carting-start', title: 'Carting Start', datetime: c.start_time, record: c });
    events.push({ key: 'carting-end', title: 'Carting End', datetime: c.end_time, record: c });
  }

  // Stuffing Start & End (if present)
  if (responseData.stuffing_data.bill_details?.length>0) {
    const { bill_details, ...stuffingRecordWithoutBills } = responseData.stuffing_data;
    events.push({ key: 'stuffing-start', title: 'Stuffing Start', datetime: responseData.stuffing_data.start_time, record: stuffingRecordWithoutBills });
    events.push({ key: 'stuffing-end', title: 'Stuffing End', datetime: responseData.stuffing_data.end_time, record: stuffingRecordWithoutBills });
  }

  // CGO (first)
  if (responseData.cgoDate?.length > 0) {
    const cgo = responseData.cgoDate[0];
    events.push({ key: 'cgo-end', title: 'CGO', datetime: cgo.end_time, record: cgo });
  }

  // Build a clean yard array with timestamps
  const yardArr = (responseData.yard_data || [])
    .filter(r => r && r.yard_created_at)
    .map(r => ({ ...r, _ts: new Date(r.yard_created_at) }))
    .filter(r => !isNaN(r._ts.getTime()));

  // ---- Placed at EWH: first yard AFTER carting end (or start if end missing) ----
  if (responseData.carting_data?.length > 0 && yardArr.length > 0) {
    const cartRec = responseData.carting_data[0];
    const cartTimeRaw = cartRec.end_time || cartRec.start_time;
    const cartTime = cartTimeRaw ? new Date(cartTimeRaw) : null;
    if (cartTime && !isNaN(cartTime.getTime())) {
      // pick yard records strictly after cartTime, choose earliest (closest after)
      const afterCart = yardArr.filter(y => y._ts > cartTime);
      if (afterCart.length > 0) {
        const placed = afterCart.reduce((a, b) => (a._ts < b._ts ? a : b));
        events.push({
          key: 'yard-placed-ewh',
          title: 'Placed at EWH',
          datetime: placed.yard_created_at,
          destination: placed.to,
          record: placed
        });
      }
    }
  }

  // ---- Picked from Yard: yard record immediately BEFORE CGO end ----
  if (responseData.cgoDate?.length > 0 && yardArr.length > 0) {
    const cgoRec = responseData.cgoDate[0];
    const cgoTimeRaw = cgoRec.end_time || cgoRec.yard_created_at || null;
    const cgoTime = cgoTimeRaw ? new Date(cgoTimeRaw) : null;
    if (cgoTime && !isNaN(cgoTime.getTime())) {
      // pick yard records strictly before cgoTime, choose latest (closest before)
      const beforeCgo = yardArr.filter(y => y._ts < cgoTime);
      if (beforeCgo.length > 0) {
        const picked = beforeCgo.reduce((a, b) => (a._ts > b._ts ? a : b));
        // avoid duplicate if same yard row already added
        const duplicate = events.some(e => e.record && e.record.yard_created_at === picked.yard_created_at);
        if (!duplicate) {
          events.push({
            key: 'yard-picked',
            title: 'Picked from Yard',
            datetime: picked.yard_created_at,
            destination: picked.from,
            record: picked
          });
        }
      }
    }
  }

  // De-Stuffing Start & End
  if (responseData.deStuffingData) {
    events.push({ key: 'destuff-start', title: 'De-Stuffing Start', datetime: responseData.deStuffingData.start_time, record: responseData.deStuffingData });
    events.push({ key: 'destuff-end', title: 'De-Stuffing End', datetime: responseData.deStuffingData.end_time, record: responseData.deStuffingData });
  }

  // Rake Inward (first)
  if (responseData.rake_in_data?.length > 0) {
    const rIn = responseData.rake_in_data[0];
    events.push({ key: 'rake-in', title: 'Rake Inward', datetime: rIn.arrival_time, wagon: rIn.wagon_no, record: rIn });
  }

  // Delivery Start & End
  if (responseData.delivery_data?.length > 0) {
    const d = responseData.delivery_data[0];
    events.push({ key: 'delivery-start', title: 'Delivery Start', datetime: d.start_time, record: d });
    events.push({ key: 'delivery-end', title: 'Delivery End', datetime: d.end_time, record: d });
  }

  // Rake Out (first)
  if (responseData.rake_data?.length > 0) {
    const r = responseData.rake_data[0];
    events.push({ key: 'rake-out', title: 'Rake Out', datetime: r.updated_at, wagon: r.wagon_no, record: r });
  }

  // CGI (if you still want it in timeline)
  if (responseData.cgiData?.length > 0) {
    const cgil = responseData.cgiData[0];
    if (cgil.end_time) events.push({ key: 'cgi', title: 'CGI', datetime: cgil.end_time, record: cgil });
  }

  // SJO
  const sjo = responseData.sjoData?.[0];
  if(sjo?.CREATED_AT){
    events.push({key:"sjo", title: 'SJO', datetime: sjo.JOB_DATE, record: sjo, JOB_NO: sjo.JOB_NO || '',})
  }
  // final: sort chronologically
  events.sort((a, b) => new Date(a.datetime) - new Date(b.datetime));

const yardRecordsToShow = useMemo(() => {
  // order matters: placed first then picked (adjust if you want different order)
  const keys = ["yard-placed-ewh", "yard-picked"];
  return keys
    .map(k => events.find(e => e.key === k)?.record) // find record by event key
    .filter(Boolean); // remove missing
}, [events]);
  // Handle click to open detail modal
  function openDetailModal(event) {
    setDetailData(event);
    setShowDetailModal(true);
  }


  return (
     <div
          className="position-relative"
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "100vh",
          }}
        >
    <div >
      {/* Header */}
         
<header className="dashboard-header py-4">
  <div className="container-fluid">
    <div className="d-flex align-items-center justify-content-between">

      {/* LEFT: Logo */}
      <div className="logo-area d-flex align-items-center me-3" style={{ minWidth: 100 }}>
        <img
          src={icdLogo}
          alt="ICD TKD"
          style={{ maxHeight: 110, objectFit: "contain", display: "block" }}
        />
      </div>

      {/* CENTER: Title + subtitle + badge */}
      <div className="title-area flex-grow-1 d-flex flex-column align-items-center px-3">
        <h1 className="display-5 fw-bold mb-1 text-secondary text-center text-secondry">
          Customer <span className="text-primary">Dashboard</span>
        </h1>

        <p className="subtitle lead mb-2 text-center">
          AI-Powered Real-Time Status & Tracking Dashboard
        </p>

        <div className="badge-area d-inline-block p-1 px-2 border rounded bg-light shadow-sm">
          <small className="fw-bold text-primary">For ICD Tughlakabad</small>
        </div>
      </div>

      {/* RIGHT: Search (select above, input+button) */}
      <div className="search-area ms-3" style={{ minWidth: 260 }}>
        <form onSubmit={handleSearchSubmit} id="formAuthentication" className="mb-0">
          <div className="mb-2">
            <select
              name="transactionType"
              className="form-select"
              value={searchForm.transactionType}
              onChange={handleSearchChange}
              required
            >
              <option value="" hidden>Select Transaction Type</option>
              <option value="Export">Export</option>
              <option value="Import">Import</option>
            </select>
          </div>

          <div className="input-group">
            <input
              type="text"
              name="crnNumber"
              className="form-control"
              placeholder="CRN/Container Number"
              value={searchForm.crnNumber}
              onChange={(e) =>
                setSearchForm((prev) => ({ ...prev, crnNumber: e.target.value.toUpperCase() }))
              }
              required
            />
            <button
              type="submit"
              className="btn btn-search"
              disabled={isLoading}
               style={{ backgroundColor: "#C75000", borderColor: "#C75000", color: "#fff" }}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  Searching...
                </>
              ) : (
                "Search"
              )}
            </button>
          </div>
        </form>
      </div>

    </div>
  </div>
</header>


      {/* Main Content */}
      <div className="container mb-5">
        <div className="row g-4">
          {/* Timeline Column */}
          <div className="col-lg-4">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-white border-0 py-3">
                <h5 className="mb-0 text-primary">Container Movement </h5>
              </div>
              <div className="card-body">
             <div className="timeline">
              {events.map((e, i) => {
                const { date, time } = formatDateTime(e.datetime);
                return (
                  <TimelineItem
                    key={e.key}
                    title={e.title}
                    date={date}
                    time={time}
                    wagon={e.wagon}
                    gate_no={e.gate_no}
                    JOB_NO={e.JOB_NO}
                    destination={e.destination}
                    last={i === events.length - 1}
                    onClick={() => openDetailModal(e)}
                  />
                );
              })}
            </div>
              </div>
            </div>
          </div>

          {/* Status Cards Column */}
          <div className="col-lg-8">
            <div className="row g-4">
              {/* Damage Status */}
            <div className="col-md-6">
  <div className="card border-0 shadow-sm h-100">
    <div className="card-header bg-white border-0 py-3">
      <div className="d-flex justify-content-between ">
      <div>
  {/* If userInput length = 10 → show CRN, else Container */}
  <h5 className="text-primary mb-2">
    {responseData?.userInput?.length === 10 ? "CRN" : "Container"}
  </h5>

  <span className="fw-bold">
    {responseData?.userInput || "N/A"}
  </span>
</div>

 <div>
          <h5 className=" text-primary ">Final Status</h5>
          <span className="fw-bold">
         {responseData?.rake_data?.length > 0 && (
  <div>Departed</div>
)}
 <div className="small text-muted ">
    {responseData?.rake_data?.[0]?.created_at ? (
      <span className="fw-bold">
        {new Date(responseData.rake_data[0].created_at).toLocaleString("en-US", {
          month: "short", // "May"
          day: "numeric", // "14"
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,   // 12-hour format with AM/PM
        })}
      </span>
    ) : (
      ""
    )}
  </div>
          </span>
        </div>

      </div>

      {/* <h5 className="mb-0 text-primary">Container Status</h5> */}
    </div>

    <div className="card-body">
      <div className="d-flex justify-content-between mb-3">
        {/* <div>
          <h6 className="text-muted mb-1 text-secondry">Damage Status</h6>
          <StatusBadge status={responseData?.gate_data?.[0]?.is_container_damage || "N"} />
        </div> */}

       
        
       <div>
  <h5 className="mb-0 text-primary">Last Yard Location</h5>
  <span className="fw-bold">
    {responseData?.icdCurData?.[0]?.to || "N/A"}
  </span>
  <div className="small text-muted mt-1">
    {responseData?.icdCurData?.[0]?.yard_created_at ? (
      <span className="fw-bold">
        {new Date(responseData.icdCurData[0].yard_created_at).toLocaleString("en-US", {
          month: "short", // "May"
          day: "numeric", // "14"
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,   // 12-hour format with AM/PM
        })}
      </span>
    ) : (
      "Timestamp not available"
    )}
  </div>
</div>

         <div>
          <h5 className="text-muted mb-1 text-primary">Hazardous</h5>
          <StatusBadge status={responseData?.gate_data?.[0]?.hazardous_container || "N"} />
        </div>
      </div>

      {/* {responseData.yard_data?.length > 0 && (
        <div className="mt-4">
          <h6 className="text-muted mb-2">Current Location</h6>
          <div className="bg-light p-3 rounded">
            <span className="fs-4 fw-bold">
              {responseData.yard_data[0].to || "N/A"}
            </span>
          </div>
        </div>
      )} */}
    </div>
  </div>
</div>


              {/* Shipping Info */}
              <div className="col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-header bg-white border-0 py-3">
                    <h5 className="mb-0 text-primary">Shipping Details</h5>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <h6 className="text-muted mb-1 text-secondry">Shipping Line</h6>
                      <p className="mb-0 fw-bold">
                        {responseData?.stuffing_data?.shipping_liner_code || "N/A"}
                      </p>
                    </div>
                    
                    {/* <div className="mb-3">
                      <h6 className="text-muted mb-1">Container Size</h6>
                      <p className="mb-0 fw-bold">
                        {responseData?.gate_data?.[0]?.container_size || "N/A"}
                      </p>
                    </div> */}
                    
                    <div className="mb-3">
                      <h6 className="text-muted mb- text-secondry">Permit Number</h6>
                      <p className="mb-0 fw-bold">
                        {responseData?.gate_data?.[0]?.permit_no || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Detailed Sections */}
              <div className="col-12">
                <div className="card border-0 shadow-sm">
                  <div className="card-header bg-white border-0 py-3">
                    <h5 className="mb-0 text-primary">Transaction Details</h5>
                  </div>
                  <div className="card-body">
                    <div className="accordion" id="transactionAccordion">
                      {/* Gate Transactions */}
                      <div className="accordion-item border-0 mb-3">
                        <h2 className="accordion-header" id="gateHeading">
                          <button 
                            className="accordion-button bg-light text-primary fw-bold" 
                            type="button" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#gateCollapse" 
                            aria-expanded="true" 
                            aria-controls="gateCollapse"
                          >
                            Gate Transactions
                          </button>
                        </h2>
                        <div 
                          id="gateCollapse" 
                          className="accordion-collapse collapse show" 
                          aria-labelledby="gateHeading" 
                          data-bs-parent="#transactionAccordion" 
                        >
                          <div className="accordion-body p-0">
                            {responseData.gate_data?.length > 0 ? (
                              <div className="table-responsive">
                                <table className="table table-hover align-middle">
                                  <thead className="table-light">
                                    <tr>
                                     <th style={{ minWidth: '140px' }}>Container/CRN No</th>
      <th style={{ minWidth: '120px' }}>Vehicle No</th>
      <th style={{ minWidth: '150px' }}>Gate In Time</th>
      <th style={{ minWidth: '120px' }}>Permit No</th>
      <th style={{ minWidth: '100px' }}>Damage</th>
      <th style={{ minWidth: '110px' }}>Hazardous</th>
      <th style={{ minWidth: '110px' }}>Gate No</th>
      <th style={{ minWidth: '110px' }}>SLINE Code</th>

      <th ></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                {responseData.gate_data.map((item, index) => (
  <tr key={index}>
    <td>{item.container_no || "N/A"}</td>
    <td>{item.vehicle_no || "N/A"}</td>
    <td>
      <div className="d-flex flex-column">
        <span>{formatDateTime(item.gate_in_time).date}</span>
        <small className="text-muted">{formatDateTime(item.gate_in_time).time}</small>
      </div>
    </td>
    <td>{item.permit_no || "N/A"}</td>
    <td><StatusBadge status={item.is_container_damage || "N"} /></td>
    <td><StatusBadge status={item.hazardous_container || "N"} /></td>
    <td>{item.gate_no || "N/A"}</td>
    <td>{item.sline_code || "N/A"}</td>

   <td>
  <button
    className="btn btn-sm btn-primary"
    onClick={() => {
      const images = [
        { title: "Vehicle No Image", url: `https://ctas.live/ocr_backend/uploads/${item.vehicle_no_img}` }
      ];

      // check permit_no prefix (case-insensitive)
      if (item.permit_no && /^(pma|pmd|gpcp)/i.test(item.permit_no)) {
        images.push({
          title: "Container Image",
          url: `https://ctas.live/ocr_backend/uploads/${item.container_image}`
        });
      }

      handleOpenModal(images);
    }}
  >
    Evidence
  </button>
</td>

  </tr>
))}

                                  </tbody>
                                </table>
                              </div>
                            ) : <div className="p-3 text-center text-muted">No gate transaction data available</div>}
                          </div>
                        </div>
                      </div>

                      {/* Carting Transactions */}
                      <div className="accordion-item border-0 mb-3">
                        <h2 className="accordion-header" id="cartingHeading">
                          <button 
                            className="accordion-button bg-light text-primary fw-bold" 
                            type="button" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#cartingCollapse" 
                            aria-expanded="false" 
                            aria-controls="cartingCollapse"
                          >
                            Carting Transactions
                          </button>
                        </h2>
                        <div 
  id="cartingCollapse" 
  className="accordion-collapse collapse" 
  aria-labelledby="cartingHeading" 
  data-bs-parent="#transactionAccordion"
>
  <div className="accordion-body p-0">

    {/* ─────────────── CARTING TRANSACTIONS ─────────────── */}
    {responseData.carting_data?.length > 0 ? (
      <div className="table-responsive">
        <table className="table table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th>CHA Code</th>
              <th>Shipping Line</th>
              <th>Start Time</th>
              <th>End Time</th>
              {/* <th></th> */}
            </tr>
          </thead>
          <tbody>
            {responseData.carting_data.map((item, i) => (
              <tr key={`cart-${i}`}>
                <td>{item.cha_code || "N/A"}</td>
                <td>{item.shipping_liner_code || "N/A"}</td>
                <td>
                  <div className="d-flex flex-column">
                    <span>{formatDateTime(item.start_time).date}</span>
                    <small className="text-muted">{formatDateTime(item.start_time).time}</small>
                  </div>
                </td>
                <td>
                  <div className="d-flex flex-column">
                    <span>{formatDateTime(item.end_time).date}</span>
                    <small className="text-muted">{formatDateTime(item.end_time).time}</small>
                  </div>
                </td>
                {/* <td>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => handleOpenModal(require('./soon.avif'))}
                  >
                    Evidence
                  </button>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <div className="p-3 text-center text-muted">
        No carting transaction data available
      </div>
    )}

    {/* ─────────────── CARTING TRUCK DETAILS ─────────────── */}
    {responseData.cartingTruckData?.length > 0 ? (
      <div className="table-responsive mt-4">
        <h6 className="ps-3 text-primary">Truck & Grid Details</h6>
        <table className="table table-bordered align-middle">
          <thead className="table-light">
            <tr>
              <th>Truck Number</th>
              <th>Area</th>
              <th>Grid Locations</th>
              <th>Pkg</th>
              <th>Pkgs Weight</th>
            </tr>
          </thead>
          <tbody>
            {responseData.cartingTruckData.map((truck, j) => (
              <tr key={`truck-${j}`}>
                <td>{truck.TRUCK_NUMBER}</td>
                <td>{truck.AREA}</td>
                <td>{truck.GRID_LOCATIONS}</td>
                <td>{truck.PKG}</td>
                <td>{truck.PKGS_WEIGHT}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <div className="p-3 text-center text-muted">
        No carting truck data available
      </div>
    )}

  </div>
</div>

                      </div>

                      {/* Stuffing Transactions */}
                      <div className="accordion-item border-0 mb-3">
                        <h2 className="accordion-header" id="stuffingHeading">
                          <button 
                            className="accordion-button bg-light text-primary fw-bold" 
                            type="button" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#stuffingCollapse" 
                            aria-expanded="false" 
                            aria-controls="stuffingCollapse"
                          >
                            Stuffing Transactions
                          </button>
                        </h2>
                        <div 
                          id="stuffingCollapse" 
                          className="accordion-collapse collapse" 
                          aria-labelledby="stuffingHeading" 
                          data-bs-parent="#transactionAccordion"
                        >
                          <div className="accordion-body" style={{paddingTop:"15px"}}>
                            {responseData.stuffing_data ? (
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <h6 className="text-muted">Container No</h6>
                                    <p className="fw-bold">{responseData.stuffing_data.container_no || "N/A"}</p>
                                  </div>
                                  <div className="mb-3">
                                    <h6 className="text-muted">Container Size</h6>
                                    <p className="fw-bold">{responseData.stuffing_data.size || "N/A"}</p>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <h6 className="text-muted">ISO Code</h6>
                                    <p className="fw-bold">{responseData.stuffing_data.iso_code || "N/A"}</p>
                                  </div>
                                  <div className="mb-3">
                                    <h6 className="text-muted">Shipping Line</h6>
                                    <p className="fw-bold">{responseData.stuffing_data.shipping_liner_code || "N/A"}</p>
                                  </div>
                                </div>
                                
                                <div className="col-12 mt-3">
                                  <h6 className="text-primary">Bill Details</h6>
                                  {responseData.stuffing_data.bill_details?.length > 0 ? (
                                    <div className="table-responsive">
                                      <table className="table table-hover align-middle">
                                        <thead className="table-light">
                                          <tr>
                                            <th>Grid</th>
                                            <th>Area (m²)</th>
                                            <th>No of package</th>
                                            {/* <th>Cycle Flag</th> */}
                                            <th>Package Weight</th>
                                            {/* <th></th> */}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {responseData.stuffing_data.bill_details.map((item, index) => (
                                            <tr key={index}>
                                              <td>{item.GRID_LOCATIONS || "N/A"}</td>
                                              <td>{item.AREA || "N/A"}</td>
                                              <td>{item.PKG || "N/A"}</td>
                                              {/* <td>{item.CYCLE_FLAG || "N/A"}</td> */}
                                              <td>{item.PKGS_WEIGHT || "N/A"}</td>
                                                  {/* <td><button
                  className="btn btn-sm btn-primary"
                   onClick={() => handleOpenModal(require('./soon.avif'))}
                >
                  Evidence
                </button></td> */}
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  ) : <div className="p-3 text-center text-muted">No bill details available</div>}
                                </div>
                              </div>
                            ) : <div className="p-3 text-center text-muted">No stuffing data available</div>}
                          </div>
                        </div>
                      </div>
                                 {/* {CGO} */}
                                <div className="accordion-item border-0 mb-3">
                        <h2 className="accordion-header" id="cgoHeading">
                          <button 
                            className="accordion-button bg-light text-primary fw-bold" 
                            type="button" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#cgoCollapse" 
                            aria-expanded="false" 
                            aria-controls="cgoCollapse"
                          >
                            CGO Transactions
                          </button>
                        </h2>
                        <div 
                          id="cgoCollapse" 
                          className="accordion-collapse collapse" 
                          aria-labelledby="yardHeading" 
                          data-bs-parent="#transactionAccordion"
                        >
                          <div className="accordion-body p-0">
                            {responseData.cgoDate?.length > 0 ? (
                              <div className="table-responsive">
                                <table className="table table-hover align-middle">
                                  <thead className="table-light">
                                    <tr>
                                      <th>Seal No 1</th>
                                      <th>Seal No 2</th>
                                      <th>Damage Flag</th>
                                      <th>End Time</th>

                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {responseData.cgoDate
                                      .sort((a, b) => new Date(b.yard_created_at) - new Date(a.yard_created_at))
                                      // .slice(0, 2)
                                      .map((item, index) => (
                                        <tr key={index}>
                                          <td>{item.seal1_no || "N/A"}</td>
                                          <td>{item.seal2_no || "N/A"}</td>
                                       
                                  
                                          <td><StatusBadge status={item.damage_flag || "N"} /></td>
                                                  <td>{formatDateTime(item.end_time).date}</td>
                                             <td>
      <button
        className="btn btn-sm btn-primary"
        onClick={() =>
          handleOpenModal([
            { title: "Seal No 1", url: `https://ctas.live/backend/Seal/`+item.SEAL_1_IMAGE },
            { title: "Seal No 2", url: `https://ctas.live/backend/Seal/`+item.SEAL_2_IMAGE }
          ])
        }
      >
        Evidence
      </button>
    </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              </div>
                            ) : <div className="p-3 text-center text-muted">No yard data available</div>}
                          </div>
                        </div>
                      </div>

                      {/* Yard Transactions */}
                    <div className="accordion-item border-0 mb-3">
  <h2 className="accordion-header" id="yardHeading">
    <button 
      className="accordion-button bg-light text-primary fw-bold" 
      type="button" 
      data-bs-toggle="collapse" 
      data-bs-target="#yardCollapse" 
      aria-expanded="false" 
      aria-controls="yardCollapse"
    >
      Yard Transactions
    </button>
  </h2>

  <div id="yardCollapse" className="accordion-collapse collapse" aria-labelledby="yardHeading" data-bs-parent="#transactionAccordion">
    <div className="accordion-body p-0">
      {yardRecordsToShow.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th>Container No</th>
                <th>Stack Location</th>
                <th>Timestamp</th>
                <th>Equipment</th>
                <th>Damage</th>
                {/* <th></th> */}
              </tr>
            </thead>
            <tbody>
              {yardRecordsToShow.map((item, index) => (
                <tr key={index}>
                  <td>{item.container_no || "N/A"}</td>
                  <td>{item.to || "N/A"}</td>
                  <td>
                    <div className="d-flex flex-column">
                      <span>{formatDateTime(item.yard_created_at).date}</span>
                      <small className="text-muted">{formatDateTime(item.yard_created_at).time}</small>
                    </div>
                  </td>
                  <td>{item.equipment_name || "N/A"}</td>
                  <td><StatusBadge status={item.damage_flag || "N"} /></td>
                  {/* <td>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => handleOpenModal(item.evidenceImage || require('./soon.avif'))}
                    >
                      Evidence
                    </button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="p-3 text-center text-muted">No yard data available</div>
      )}
    </div>
  </div>
</div>

                 
                      {/* Rake Outward Transactions */}
                      <div className="accordion-item border-0">
                        <h2 className="accordion-header" id="rakeHeading">
                          <button 
                            className="accordion-button bg-light text-primary fw-bold" 
                            type="button" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#rakeCollapse" 
                            aria-expanded="false" 
                            aria-controls="rakeCollapse"
                          >
                            Rake Outward Transactions
                          </button>
                        </h2>
                        <div 
                          id="rakeCollapse" 
                          className="accordion-collapse collapse" 
                          aria-labelledby="rakeHeading" 
                          data-bs-parent="#transactionAccordion"
                        >
                          <div className="accordion-body p-0">
                            {responseData.rake_data?.length > 0 ? (
                              <div className="table-responsive">
                                <table className="table table-hover align-middle">
                                  <thead className="table-light">
                                    <tr>
                                      {/* <th>Train No</th> */}
                                      <th>Wagon No</th>
                                      <th>Departure Time</th>
                                      <th>Damage</th>
                                      <th>Seal 1</th>
                                      <th>Seal 2</th>
                                      <th>Status</th>
                                      <th>ITV</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {responseData.rake_data.map((item, index) => (
                                      <tr key={index}>
                                        {/* <td>{item.train_no || "N/A"}</td> */}
                                        <td>{item.wagon_no || "N/A"}</td>
                                        <td>
                                          <div className="d-flex flex-column">
                                            <span>{formatDateTime(item.updated_at).date}</span>
                                            <small className="text-muted">{formatDateTime(item.updated_at).time}</small>
                                          </div>
                                        </td>
                                        <td><StatusBadge status={item.is_container_damage || "N"} /></td>
                                        <td>{item.seal_1_no || "N/A"}</td>
                                        <td>{item.seal_2_no || "N/A"}</td>
                                        <td>{item.container_status || "N/A"}</td>
                                        <td>{item.itv_name || "N/A"}</td>
                                            <td>
      <button
        className="btn btn-sm btn-primary"
        onClick={() =>
          handleOpenModal([
            { title: "Wagon", url: `https://ctas.live/ocr_backend/rake_ocr_1/`+item.wagon_no_image },
            { title: "Container 1", url: `https://ctas.live/ocr_backend/rake_ocr_1/`+item.container_no_image_1 },
            { title: "Container 2", url: `https://ctas.live/ocr_backend/rake_ocr_1/`+item.container_no_image_2 }
          ])
        }
      >
        Evidence
      </button>
    </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            ) : <div className="p-3 text-center text-muted">No rake data available</div>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="dashboard-footer py-3 bg-light border-top">
        <div className="container">
          {/* <p className="mb-0 text-center text-muted">
            Powered by <span className="text-primary">SUNIC TECHNOLOGIES</span>
          </p> */}
        </div>
      </footer>
     <Modal show={showModal} onHide={handleCloseModal} centered>
  <Modal.Header closeButton>
    <Modal.Title>Evidence Images</Modal.Title>
  </Modal.Header>
  <Modal.Body className="text-center">
    {popupImages && popupImages.length > 0 ? (
      popupImages.map((img, index) => (
        <div key={index} className="mb-4">
          <h6 className="mb-2">{img.title || `Image ${index + 1}`}</h6>
          <img
            src={img.url}
            alt={img.title || `Evidence ${index + 1}`}
            style={{ maxWidth: "100%", maxHeight: "400px" }}
            className="rounded shadow-sm"
          />
        </div>
      ))
    ) : (
      <p>No images available</p>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={handleCloseModal}>
      Close
    </Button>
  </Modal.Footer>
</Modal>


        <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">{detailData?.title} Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {detailData ? (
            <table className="table table-striped">
              <tbody>
                {Object.entries(detailData.record).map(([key, val]) => (
                  <tr key={key}>
                    <th style={{ textTransform: 'capitalize' }}>{key.replace(/_/g, ' ')}</th>
                    <td>
                      {typeof val === 'string' && Date.parse(val)
                        ? `${formatDateTime(val).date} ${formatDateTime(val).time}`
                        : val != null
                        ? String(val)
                        : ''}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No data available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    </div>
  );
};

export default Secondpagee;